module.exports = __webpack_public_path__ + "static/media/AI-search-campaign-03.7097b235.svg";